var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaintenanceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.509,
    height: 80.218,
    viewBox: "0 0 80.509 80.218",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_206",
    "data-name": "Group 206",
    transform: "translate(0.613 0.613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M469.352,104.265a15.621,15.621,0,0,1-6.38-1.354.981.981,0,0,1-.294-1.589l7.638-7.644a4.268,4.268,0,1,0-6.035-6.036l-7.638,7.644a.981.981,0,0,1-1.589-.292,15.715,15.715,0,0,1,19.582-21.24l7.02-7.02a.981.981,0,1,1,1.387,1.387l-7.468,7.468a.983.983,0,0,1-1.059.217,13.752,13.752,0,0,0-18.194,17.027l6.572-6.578a6.229,6.229,0,1,1,8.81,8.809l-6.572,6.578a13.751,13.751,0,0,0,17.021-18.2.981.981,0,0,1,.217-1.06l6.814-6.807a.981.981,0,1,1,1.386,1.389L484.2,83.323a15.693,15.693,0,0,1-14.852,20.942",
    transform: "translate(-453.696 -28.091)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M522.3,44.876A.981.981,0,0,1,521.6,43.2l6.723-6.729a.98.98,0,0,1,1.059-.218,13.755,13.755,0,0,0,18.2-17.027l-6.573,6.578a6.232,6.232,0,1,1-8.81-8.816l6.571-6.571a13.747,13.747,0,0,0-17.02,18.2.981.981,0,0,1-.217,1.059l-7.383,7.383a.981.981,0,0,1-1.387-1.387l6.935-6.935A15.712,15.712,0,0,1,540.937,9.15a.98.98,0,0,1,.294,1.589l-7.638,7.638a4.27,4.27,0,0,0,6.036,6.042l7.638-7.645a.98.98,0,0,1,1.588.292,15.716,15.716,0,0,1-19.586,21.24l-6.276,6.281a.98.98,0,0,1-.695.288",
    transform: "translate(-474.038 -7.796)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M533.815,63.811a.982.982,0,0,0-.427-.719l-13.748-9.3-.022-.015a7.326,7.326,0,0,0-9.169,1.006l-2.142,2.142L462.124,10.745a3.4,3.4,0,0,0-2.491-1,3.627,3.627,0,0,0-3.543,3.543,3.4,3.4,0,0,0,1,2.491l46.182,46.183-2.14,2.14a7.333,7.333,0,0,0-.991,9.192l9.3,13.748a.979.979,0,0,0,.719.427c.031,0,.062,0,.094,0a.981.981,0,0,0,.694-.288l4.518-4.518.007-.007,6.77-6.769h0L533.532,64.6a.982.982,0,0,0,.283-.787M458.052,13.325a1.665,1.665,0,0,1,1.616-1.617h.028a1.458,1.458,0,0,1,1.041.424L506.92,58.315l-2.261,2.261L458.476,14.394a1.46,1.46,0,0,1-.424-1.069m44.466,52.167,9.318-9.318a5.377,5.377,0,0,1,6.717-.746l.173.117L501.888,72.382l-.109-.162a5.375,5.375,0,0,1,.738-6.728m24.9,2.448-6.874-4.124a.981.981,0,0,0-1.009,1.682l6.453,3.872-4.442,4.442-3.072-3.072a.981.981,0,0,0-1.387,1.387l3.072,3.072-5.238,5.238L509.558,72.4a.981.981,0,0,0-1.632,1.088l5.578,8.367-3.109,3.109-7.387-10.923,17.373-17.373L531.3,64.051Z",
    transform: "translate(-454.525 -8.471)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenanceIcon);
export default __webpack_public_path__ + "static/media/maintenance-icon.6fe083b8e101157edd287967e1c28e65.svg";
export { ForwardRef as ReactComponent };